var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKoi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "leftKoi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.686,377.469c0,-0 8.57,34.024 9.827,49.74c1.258,15.716 12.637,64.044 37.817,82.509c25.18,18.466 62.235,32.622 78.603,35.492c2.037,0.358 13.773,2.886 14.9,3.449",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.472,399.648c0,0 7.775,31.856 8.511,42.906c0.737,11.051 12.721,66.792 78.95,91.842c-0,0 -68.587,-22.835 -80.129,-67.283c-11.542,-44.447 -15.962,-67.285 -26.276,-76.494c-10.314,-9.208 -15.716,-8.963 -18.786,-9.208",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.704,526.337c-0,0 -43.271,-46.433 -50.218,-77.309c-1.105,-4.911 -11.91,-42.851 -18.54,-44.816c-6.63,-1.964 -13.261,-0.614 -16.085,0.491",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.704,526.337c-0,0 -38.42,-28.337 -43.681,-94.522",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.689,503.009c0,-0 -20.412,-27.78 -25.784,-41.44c-5.372,-13.659 -17.343,-16.269 -21.027,-17.036",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.833,474.922c-0,0 17.451,49.121 20.214,83.65",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.74,558.781c-0,-0 -3.33,-53.604 -8.126,-61.469c-0,-0 2.753,-12.864 -6.991,-10.286c-13.021,3.444 26.384,-15.245 14.218,-115.291c-12.166,-100.046 -11.416,-98.21 32.049,-159.999c0,-0 -48.337,19.147 -60.327,79.1c-0,-0 -0,7.494 -5.995,7.869c-5.996,0.374 -21.733,20.234 -16.113,49.836c0,-0 -0.749,4.121 -5.995,8.243c-5.246,4.122 -5.621,2.248 -10.866,3.372c-5.246,1.125 -4.149,2.463 -4.443,6.49c-0.295,4.028 -17.583,-19.743 -19.253,-24.065c-1.67,-4.322 -71.32,-164.101 93.501,-199.465c13.098,-2.811 30.394,-1.305 53.379,8.431c52.069,22.055 117.772,103.1 160.362,125.546c42.591,22.446 72.327,8.058 79.81,8.441c-0,0 -29.737,-24.556 -51.224,-28.777c-0,0 -10.552,-24.748 -19.952,-31.463c-0,-0 1.918,-30.504 -17.459,-56.787c0,-0 24.365,-3.646 36.452,-16.116c-0,0 33.573,-2.494 47.77,-3.453c0,-0 41.999,42.399 101.872,18.801c-0,0 -39.121,-8.441 -58.882,-20.144c-19.76,-11.703 -134.869,-67.723 -152.903,-71.56c-18.034,-3.837 -100.113,-17.458 -190.969,25.708c-0,0 -12.007,0 -28.314,4.221c-16.308,4.22 -85.949,34.341 -92.472,37.218c0,0 9.785,-32.806 33.958,-43.549c24.173,-10.744 24.556,-22.83 29.736,-31.463c0,-0 -15.161,19.164 -35.3,23.789c-51.799,11.894 -71.368,23.981 -78.658,36.259c-0,0 -26.859,-4.988 -46.044,53.334c0,0 -45.852,34.341 -45.468,66.38c0.384,32.039 15.075,65.394 22.557,80.358c7.482,14.964 -1.726,135.253 4.029,146.572c0,0 -23.789,-43.166 -39.905,-41.823c0,0 -7.482,-11.127 -9.592,-20.911c-2.11,-9.785 -13.202,-23.869 -33.73,-12.55c0,0 -9.436,-21.024 -16.151,-22.559c-6.714,-1.534 -10.935,-5.947 -22.638,0.576c0,-0 -6.331,-15.924 -28.969,-22.063c-22.638,-6.139 -36.451,-22.446 -40.097,-30.696c0,0 5.372,55.061 53.526,68.107c0,-0 9.401,9.976 11.128,19.185c1.726,9.208 14.964,59.281 21.487,70.6c6.523,11.319 18.033,33.19 39.904,43.742c21.871,10.551 63.119,27.369 85.373,32.102c0,0 2.686,10.68 3.453,13.174c0.768,2.494 2.302,4.221 6.331,5.755c4.029,1.535 14.773,25.845 19.761,33.738c4.988,7.894 12.17,19.771 13.19,21.365m-222.174,-279.833c0,-0 33.389,21.382 30.402,52.866m-8.552,-30.938c0,0 -16.877,-8.804 -25.49,-13.016c-8.612,-4.212 -26.125,-23.202 -28.339,-36.847m187.053,3.454c0,-0 30.711,38.215 39.92,56.94c9.209,18.724 1.842,25.477 36.375,56.48c34.532,31.003 46.811,66.275 52.643,75.037c-0,0 -24.016,-62.304 -71.368,-103.737c-1.228,-1.075 -11.664,-40.672 -25.631,-59.243c-13.966,-18.571 -30.082,-46.351 -31.923,-55.253c-1.842,-8.902 -13.967,-34.84 -9.976,-60.47c3.99,-25.631 11.009,-34.345 18.243,-43.801",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.558,295.22c0,0 1.766,49.674 5.363,64.063c3.598,14.389 14.569,43.757 14.749,68.526c-0,0 -8.556,-85.438 -12.167,-93.218c-1.503,-3.237 1.555,-69.132 9.109,-84.713",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.319,305.43c-0,0 -2.441,36.648 2.955,53.195c5.395,16.547 19.604,45.406 20.863,55.077c1.259,9.672 4.398,30.237 2.739,57.334",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.821,484.946c-0,0 -4.59,-25.565 -12.936,-37.507c-8.345,-11.943 -27.626,-44.03 -37.266,-59.569c-9.641,-15.54 -7.482,-18.13 -5.9,-20.864c1.583,-2.734 11.08,14.101 13.813,20.144c2.734,6.044 26.476,53.814 29.353,60.289",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.75,479.751c-0,-0 5.222,-23.643 -6.829,-59.615c-12.05,-35.971 -19.744,-46.223 -20.843,-57.015c-1.099,-10.791 -3.977,-12.59 -5.416,-15.468",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.857,101.009c0,0 -35.883,19.367 -34.984,97.83c0,-0 -3.822,-61.826 38.895,-99.147",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.605,128.218c-0,0 -15.811,35.773 -15.362,109.291c0,-0 4.272,-112.637 55.307,-134.445",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.712,153.617c0,0 -10.873,61.203 11.834,164.133c-0,-0 -24.96,-181.997 21.803,-189.416",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,185.636c0,0 -22.095,84.426 38.383,200.328c-0,-0 -46.339,-99.661 -32.638,-204.345",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.588,516.747c-0,0 -16.798,-45.528 -27.365,-58.568c-10.566,-13.039 -30.576,-95.549 -29.452,-116.233c1.125,-20.684 -1.273,-79.033 35.298,-126.575c2.248,-2.923 7.644,-50.136 7.194,-59.803c-0.45,-9.668 3.039,-11.44 4.784,-12.524",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.613,142.062c0,0 -25.723,-3.984 -17.914,-6.194c7.809,-2.211 58.862,-8.62 52.895,-16.65c-5.967,-8.03 -19.309,-12.995 -32.5,-12.818c-5.514,0.073 -25.847,12.597 -21.205,5.967c4.489,-6.413 9.65,-7.957 4.936,-9.504c-4.715,-1.547 -3.095,-1.031 -5.157,-1.178",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.726,256.757c-0,0 3.768,27.325 27.372,32.629",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.436,278.479c-0,0 -25.612,-0.878 -58.347,-21.722c-32.734,-20.844 -106.55,-123.004 -183.995,-114.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.774,225.294c-0,-0 -36.454,-34.742 -147.966,-84.743c-0,0 101.26,28.395 148.203,79.138",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.114,167.785c-0,-0 -63.442,-43.421 -155.17,-48.277c-0,-0 128.059,20.504 159.714,62.591",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.767,152.391c-0,0 -45.805,-44.034 -170.502,-44.574c0,0 127.465,14.389 164.516,48.742",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.537,148.938c0,-0 47.25,1.991 67.662,9.293",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.368,151.665c0,-0 -45.826,-19.391 -87.418,-43.447c-41.593,-24.056 -83.699,-29.915 -102.52,-33.948c-9.442,-2.023 -40.693,0.225 -57.105,0.674",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.614,497.312c-0,-0 -7.792,1.624 -21.282,35.258c-13.489,33.633 -18.525,31.295 -21.223,34.713c-2.698,3.417 -8.094,-4.317 -3.058,-7.375c5.036,-3.057 15.468,-27.338 17.447,-33.094c1.978,-5.755 14.748,-39.209 18.885,-39.568",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.981,563.453c-0,0 -10.27,-2.805 -12.48,4.684c-2.21,7.489 -16.115,0.03 -19.706,-2.18c-3.592,-2.21 -6.354,-6.815 -8.933,-7.275c-2.578,-0.46 -9.301,3.039 -6.722,10.222c2.578,7.183 -4.513,7.459 -8.012,7.919c-3.499,0.461 -6.078,-0.644 -6.17,4.144c-0.092,4.789 5.71,5.433 5.065,8.196c-0.645,2.763 -8.03,7.367 -8.435,9.301",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.799,577.501c0,0 6.475,-1.838 18.616,3.333c12.14,5.171 52.833,21.358 60.927,22.257c8.094,0.9 12.506,2.474 15.246,0.9l-0,-5.621c-0,0 -44.023,-11.466 -53.241,-17.086c-9.218,-5.621 -43.705,-18.187 -50,-17.737",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.588,603.991c-0,-0 -6.765,21.833 29.513,24.623c2.338,0.18 6.295,7.375 5.216,12.051c-1.079,4.676 7.374,11.871 21.043,4.856c13.67,-7.014 30.217,-24.525 35.433,-40.86c5.216,-16.335 -11.152,-13.637 -15.648,-16.695c-4.497,-3.057 3.058,-8.993 -0.18,-15.467c-3.237,-6.475 -2.158,-2.069 -5.576,-4.362",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.399,611.239c0,0 2.099,-2.782 2.099,-11.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.994,712.374c0,-0 9.857,19.815 50.181,-4.857c12.344,-7.552 18.166,-16.547 15.648,-28.057c-0,-0 -11.511,17.806 -23.562,25.539c-12.05,7.734 -20.504,12.411 -42.267,7.375Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.994,712.374c0,-0 20.469,2.235 24.153,-6.237c3.683,-8.472 6.538,-18.878 -6.907,-43.465c0,-0 15.379,33.888 27.903,30.665c12.524,-3.223 12.616,-4.917 20.443,-13.877",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.994,712.374c0,-0 -60.653,-38.223 -74.502,-42.719c-0,-0 3.415,-34.173 -43.706,-37.051c-0,-0 -1.077,5.036 8.635,14.748c-0,0 18.166,-1.619 28.058,19.965l7.013,2.338l-6.718,-2.358c-0,-0 -25.765,0.169 -27.981,-19.761",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.246,706.916c-0,0 -7.913,6.474 -15.511,5.458c-7.597,-1.016 -20.719,-11.376 -26.935,-8.729c-6.216,2.648 -23.252,20.029 -31.08,18.878c-7.827,-1.151 -13.238,-4.719 -19.453,-12.201c-0,-0 13.928,15.655 23.137,7.482c9.208,-8.173 15.309,-18.878 20.719,-20.144c5.41,-1.266 14.151,-0.726 22.677,5.065c2.357,1.601 11.856,0.92 12.662,-0.576c0.806,-1.496 1.381,-2.469 1.381,-2.469",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.046,660.574c-0,0 8.136,-3.524 10.53,-8.957c2.395,-5.433 7.556,-11.906 5.938,-34.389c-0,0 1.877,31.296 -0.101,35.433c-1.979,4.136 -11.528,12.667 -12.818,14.693c-1.289,2.026 -1.211,2.573 -1.211,2.573l1.439,9.533c-0,-0 -0.36,-5.216 -1.439,-9.533c-1.079,-4.317 -5.036,-2.698 -2.338,-9.353Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.399,657.452l0,-46.213",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.399,611.239c0,0 -12.221,-5.027 -11.73,-23.886c0.491,-18.86 -0.589,-19.744 10.019,-28.781c0,0 3.143,5.599 3.143,11.394c0,0 -8.644,15.127 0.59,29.96c-0,-0 9.821,-16.222 0.784,-28.717c-1.958,-2.707 -1.374,-1.243 -1.374,-1.243",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "rightKoi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.314,622.531c-0,0 -8.57,-34.024 -9.827,-49.74c-1.258,-15.716 -12.637,-64.044 -37.817,-82.509c-25.18,-18.466 -62.235,-32.622 -78.603,-35.492c-2.037,-0.358 -13.773,-2.886 -14.9,-3.449",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.528,600.352c-0,-0 -7.775,-31.856 -8.511,-42.906c-0.737,-11.051 -12.721,-66.792 -78.95,-91.842c0,-0 68.587,22.835 80.129,67.283c11.542,44.447 15.962,67.285 26.276,76.494c10.314,9.208 15.716,8.963 18.786,9.208",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.296,473.663c0,-0 43.271,46.433 50.218,77.309c1.105,4.911 11.91,42.851 18.54,44.816c6.63,1.964 13.261,0.614 16.085,-0.491",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.296,473.663c0,-0 38.42,28.337 43.681,94.522",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.311,496.991c-0,0 20.412,27.78 25.784,41.44c5.372,13.659 17.343,16.269 21.027,17.036",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.167,525.078c0,-0 -17.451,-49.121 -20.214,-83.65",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.26,441.219c0,0 3.33,53.604 8.126,61.469c0,0 -2.753,12.864 6.991,10.286c13.021,-3.444 -26.384,15.245 -14.218,115.291c12.166,100.046 11.416,98.21 -32.049,159.999c-0,0 48.337,-19.147 60.327,-79.1c0,0 0,-7.494 5.995,-7.869c5.996,-0.374 21.733,-20.234 16.113,-49.836c-0,0 0.749,-4.121 5.995,-8.243c5.246,-4.122 5.621,-2.248 10.866,-3.372c5.246,-1.125 4.149,-2.463 4.443,-6.49c0.295,-4.028 17.583,19.743 19.253,24.065c1.67,4.322 71.32,164.101 -93.501,199.465c-13.098,2.811 -30.394,1.305 -53.379,-8.431c-52.069,-22.055 -117.772,-103.1 -160.362,-125.546c-42.591,-22.446 -72.327,-8.058 -79.81,-8.441c0,-0 29.737,24.556 51.224,28.777c0,-0 10.552,24.748 19.952,31.463c0,0 -1.918,30.504 17.459,56.787c-0,0 -24.365,3.646 -36.452,16.116c0,-0 -33.573,2.494 -47.77,3.453c-0,0 -41.999,-42.399 -101.872,-18.801c0,-0 39.121,8.441 58.882,20.144c19.76,11.703 134.869,67.723 152.903,71.56c18.034,3.837 100.113,17.458 190.969,-25.708c0,-0 12.007,-0 28.314,-4.221c16.308,-4.22 85.949,-34.341 92.472,-37.218c-0,-0 -9.785,32.806 -33.958,43.549c-24.173,10.744 -24.556,22.83 -29.736,31.463c-0,0 15.161,-19.164 35.3,-23.789c51.799,-11.894 71.368,-23.981 78.658,-36.259c0,-0 26.859,4.988 46.044,-53.334c-0,-0 45.852,-34.341 45.468,-66.38c-0.384,-32.039 -15.075,-65.394 -22.557,-80.358c-7.482,-14.964 1.726,-135.253 -4.029,-146.572c-0,-0 23.789,43.166 39.905,41.823c-0,-0 7.482,11.127 9.592,20.911c2.11,9.785 13.202,23.869 33.73,12.55c-0,-0 9.436,21.024 16.151,22.559c6.714,1.534 10.935,5.947 22.638,-0.576c-0,0 6.331,15.924 28.969,22.063c22.638,6.139 36.451,22.446 40.097,30.696c-0,-0 -5.372,-55.061 -53.526,-68.107c-0,0 -9.401,-9.976 -11.128,-19.185c-1.726,-9.208 -14.964,-59.281 -21.487,-70.6c-6.523,-11.319 -18.033,-33.19 -39.904,-43.742c-21.871,-10.551 -63.119,-27.369 -85.373,-32.102c-0,-0 -2.686,-10.68 -3.453,-13.174c-0.768,-2.494 -2.302,-4.221 -6.331,-5.755c-4.029,-1.535 -14.773,-25.845 -19.761,-33.738c-4.988,-7.894 -12.17,-19.771 -13.19,-21.365m222.174,279.833c-0,0 -33.389,-21.382 -30.402,-52.866m8.552,30.938c-0,-0 16.877,8.804 25.49,13.016c8.612,4.212 26.125,23.202 28.339,36.847m-187.053,-3.454c-0,0 -30.711,-38.215 -39.92,-56.94c-9.209,-18.724 -1.842,-25.477 -36.375,-56.48c-34.532,-31.003 -46.811,-66.275 -52.643,-75.037c0,-0 24.016,62.304 71.368,103.737c1.228,1.075 11.664,40.672 25.631,59.243c13.966,18.571 30.082,46.351 31.923,55.253c1.842,8.902 13.967,34.84 9.976,60.47c-3.99,25.631 -11.009,34.345 -18.243,43.801",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.442,704.78c-0,-0 -1.766,-49.674 -5.363,-64.063c-3.598,-14.389 -14.569,-43.757 -14.749,-68.526c0,-0 8.556,85.438 12.167,93.218c1.503,3.237 -1.555,69.132 -9.109,84.713",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.681,694.57c0,-0 2.441,-36.648 -2.955,-53.195c-5.395,-16.547 -19.604,-45.406 -20.863,-55.077c-1.259,-9.672 -4.398,-30.237 -2.739,-57.334",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.179,515.054c0,-0 4.59,25.565 12.936,37.507c8.345,11.943 27.626,44.03 37.266,59.569c9.641,15.54 7.482,18.13 5.9,20.864c-1.583,2.734 -11.08,-14.101 -13.813,-20.144c-2.734,-6.044 -26.476,-53.814 -29.353,-60.289",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.25,520.249c0,0 -5.222,23.643 6.829,59.615c12.05,35.971 19.744,46.223 20.843,57.015c1.099,10.791 3.977,12.59 5.416,15.468",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.143,898.991c-0,-0 35.883,-19.367 34.984,-97.83c-0,0 3.822,61.826 -38.895,99.147",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.395,871.782c0,-0 15.811,-35.773 15.362,-109.291c-0,0 -4.272,112.637 -55.307,134.445",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.288,846.383c-0,-0 10.873,-61.203 -11.834,-164.133c0,0 24.96,181.997 -21.803,189.416",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.51,814.364c-0,-0 22.095,-84.426 -38.383,-200.328c0,0 46.339,99.661 32.638,204.345",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.412,483.253c0,-0 16.798,45.528 27.365,58.568c10.566,13.039 30.576,95.549 29.452,116.233c-1.125,20.684 1.273,79.033 -35.298,126.575c-2.248,2.923 -7.644,50.136 -7.194,59.803c0.45,9.668 -3.039,11.44 -4.784,12.524",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.387,857.938c-0,-0 25.723,3.984 17.914,6.194c-7.809,2.211 -58.862,8.62 -52.895,16.65c5.967,8.03 19.309,12.995 32.5,12.818c5.514,-0.073 25.847,-12.597 21.205,-5.967c-4.489,6.413 -9.65,7.957 -4.936,9.504c4.715,1.547 3.095,1.031 5.157,1.178",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.274,743.243c0,-0 -3.768,-27.325 -27.372,-32.629",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.564,721.521c0,-0 25.612,0.878 58.347,21.722c32.734,20.844 106.55,123.004 183.995,114.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.226,774.706c0,0 36.454,34.742 147.966,84.743c0,-0 -101.26,-28.395 -148.203,-79.138",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.886,832.215c0,0 63.442,43.421 155.17,48.277c0,0 -128.059,-20.504 -159.714,-62.591",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.233,847.609c0,-0 45.805,44.034 170.502,44.574c-0,-0 -127.465,-14.389 -164.516,-48.742",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.463,851.062c-0,0 -47.25,-1.991 -67.662,-9.293",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.632,848.335c-0,0 45.826,19.391 87.418,43.447c41.593,24.056 83.699,29.915 102.52,33.948c9.442,2.023 40.693,-0.225 57.105,-0.674",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.386,502.688c0,0 7.792,-1.624 21.282,-35.258c13.489,-33.633 18.525,-31.295 21.223,-34.713c2.698,-3.417 8.094,4.317 3.058,7.375c-5.036,3.057 -15.468,27.338 -17.447,33.094c-1.978,5.755 -14.748,39.209 -18.885,39.568",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.019,436.547c0,-0 10.27,2.805 12.48,-4.684c2.21,-7.489 16.115,-0.03 19.706,2.18c3.592,2.21 6.354,6.815 8.933,7.275c2.578,0.46 9.301,-3.039 6.722,-10.222c-2.578,-7.183 4.513,-7.459 8.012,-7.919c3.499,-0.461 6.078,0.644 6.17,-4.144c0.092,-4.789 -5.71,-5.433 -5.065,-8.196c0.645,-2.763 8.03,-7.367 8.435,-9.301",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.201,422.499c-0,-0 -6.475,1.838 -18.616,-3.333c-12.14,-5.171 -52.833,-21.358 -60.927,-22.257c-8.094,-0.9 -12.506,-2.474 -15.246,-0.9l0,5.621c0,-0 44.023,11.466 53.241,17.086c9.218,5.621 43.705,18.187 50,17.737",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.412,396.009c0,0 6.765,-21.833 -29.513,-24.623c-2.338,-0.18 -6.295,-7.375 -5.216,-12.051c1.079,-4.676 -7.374,-11.871 -21.043,-4.856c-13.67,7.014 -30.217,24.525 -35.433,40.86c-5.216,16.335 11.152,13.637 15.648,16.695c4.497,3.057 -3.058,8.993 0.18,15.467c3.237,6.475 2.158,2.069 5.576,4.362",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.601,388.761c-0,-0 -2.099,2.782 -2.099,11.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.006,287.626c-0,0 -9.857,-19.815 -50.181,4.857c-12.344,7.552 -18.166,16.547 -15.648,28.057c0,0 11.511,-17.806 23.562,-25.539c12.05,-7.734 20.504,-12.411 42.267,-7.375Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.006,287.626c-0,0 -20.469,-2.235 -24.153,6.237c-3.683,8.472 -6.538,18.878 6.907,43.465c-0,0 -15.379,-33.888 -27.903,-30.665c-12.524,3.223 -12.616,4.917 -20.443,13.877",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.006,287.626c-0,0 60.653,38.223 74.502,42.719c0,0 -3.415,34.173 43.706,37.051c0,0 1.077,-5.036 -8.635,-14.748c0,-0 -18.166,1.619 -28.058,-19.965l-7.013,-2.338l6.718,2.358c0,0 25.765,-0.169 27.981,19.761",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.754,293.084c0,-0 7.913,-6.474 15.511,-5.458c7.597,1.016 20.719,11.376 26.935,8.729c6.216,-2.648 23.252,-20.029 31.08,-18.878c7.827,1.151 13.238,4.719 19.453,12.201c0,0 -13.928,-15.655 -23.137,-7.482c-9.208,8.173 -15.309,18.878 -20.719,20.144c-5.41,1.266 -14.151,0.726 -22.677,-5.065c-2.357,-1.601 -11.856,-0.92 -12.662,0.576c-0.806,1.496 -1.381,2.469 -1.381,2.469",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.954,339.426c0,-0 -8.136,3.524 -10.53,8.957c-2.395,5.433 -7.556,11.906 -5.938,34.389c0,-0 -1.877,-31.296 0.101,-35.433c1.979,-4.136 11.528,-12.667 12.818,-14.693c1.289,-2.026 1.211,-2.573 1.211,-2.573l-1.439,-9.533c0,0 0.36,5.216 1.439,9.533c1.079,4.317 5.036,2.698 2.338,9.353Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.601,342.548l-0,46.213",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.601,388.761c-0,-0 12.221,5.027 11.73,23.886c-0.491,18.86 0.589,19.744 -10.019,28.781c-0,-0 -3.143,-5.599 -3.143,-11.394c-0,-0 8.644,-15.127 -0.59,-29.96c0,0 -9.821,16.222 -0.784,28.717c1.958,2.707 1.374,1.243 1.374,1.243",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoi);
export default __webpack_public_path__ + "static/media/koi.4166099b.svg";
export { ForwardRef as ReactComponent };